import { useEffect, useState } from "react";
import api from "./api"; 
import { useUserSuperEmpresa } from "../Context/AuthContext";

// ------------------------------------
// 🔹 Hook base: CRUD de egresos
// ------------------------------------
export const useIngresoCBO = () => {
  const { Token } = useUserSuperEmpresa();

  // 📌 Crear egreso
  const crearIngreso = async (nuevoIngreso) => {
    try {
      const { data } = await api.post("/crear/incomes-cbo", nuevoIngreso, {
        headers: { Authorization: `Bearer ${Token}` },
      });
      return data;
    } catch (error) {
      console.error("💥 Error al crear egreso:", error);
      throw error.response?.data?.message || "Error al crear egreso";
    }
  };

  // ✏️ Editar egreso
  const editarIngreso = async (id, IngresoActualizado) => {
    try {
      const { data } = await api.put(`/editar/incomes-cbo/${id}`, IngresoActualizado, {
        headers: { Authorization: `Bearer ${Token}` },
      });
      return data;
    } catch (error) {
      console.error("💥 Error al editar egreso:", error);
      throw error.response?.data?.message || "Error al editar egreso";
    }
  };

  // ❌ Eliminar egreso
  const eliminarIngreso = async (id) => {
    try {
      const { data } = await api.delete(`/eliminar/incomes-cbo/${id}`, {
        headers: { Authorization: `Bearer ${Token}` },
      });
      return data;
    } catch (error) {
      console.error("💥 Error al eliminar egreso:", error);
      throw error.response?.data?.message || "Error al eliminar egreso";
    }
  };

  return {
    crearIngreso,
    editarIngreso,
    eliminarIngreso,
  };
};

// ------------------------------------
// 🔹 Hook de consulta: obtener egresos
// ------------------------------------
export const useGetIngreso = () => {
  const { Token } = useUserSuperEmpresa();
  const [ingreso, setIngresos] = useState([]);
  const [loadingIngreso, setLoadingIngreso] = useState(false);
  const [errorIngreso, setErrorIngreso] = useState(null);

  const fetchIngreso = async () => {
    setLoadingIngreso(true);
    try {
      const { data } = await api.get("/incomes-cbo", {
        headers: { Authorization: `Bearer ${Token}` },
      });
      setIngresos(data);
      setErrorIngreso(null);
    } catch (error) {
      console.error("💥 Error al obtener ingresos:", error);
      setErrorIngreso(error.response?.data?.message || "Error al obtener Ingreso");
    } finally {
      setLoadingIngreso(false);
    }
  };

  // 🔁 Cargar automáticamente al montar
  useEffect(() => {
    fetchIngreso();
  }, []);

  return {
    ingreso,
    loadingIngreso,
    errorIngreso,
    refetchIngresos: fetchIngreso, // para recargar manualmente
  };
};
